import { commonPagesConstants } from 'store/constants';
import CommonPages, {
  CommonPagesI,
} from 'store/models/file-selected/CommonPages';
import { EachPage } from 'store/models/file-selected/file-selected.interface';
import { FileSelected } from 'store/models/file-selected/FileSelected';
import { FormattedMainFile } from 'store/models/MainFiles';
import { curBookingsBookingsSelector } from 'store/selectors/cur-bookings.selector';
import { commonPagesSelector } from 'store/selectors/cur-bookings-attachments.selector';
import { curBookingsActions } from 'store/actions/cur-bookings.actions';

/**
 * not sure when will this be used this. maybe on init. maybe will rename?
 * now it's just a generic set function
 * @param commonPages
 */
const setCommonPages = (commonPages: EachPage[]) => {
  return {
    type: commonPagesConstants.SET_COMMON_PAGES,
    payload: {
      commonPages,
    },
  };
};

/**
 *
 * @param srcFile
 * @param pageNum
 */
const addFileOrPage = (
  srcFile: FormattedMainFile,
  pageNum?: number,
) => {
  return (dispatch, getState) => {
    const commonPages = commonPagesSelector(getState());
    const commonPagesM = new CommonPages(commonPages);
    let updated: CommonPagesI;
    let res;
    if (pageNum !== undefined) {
      res = commonPagesM.addPage(srcFile.partId, pageNum);
      updated = res.result as CommonPagesI;
    } else {
      if (srcFile.pages.length === 0) {
        return;
      }
      const pageNums = srcFile.pages.map((p) => p.num);
      res = commonPagesM.addPages(srcFile.partId, pageNums);
    }
    updated = res.result as CommonPagesI;

    const fromGlobalCommonPage = res.fromGlobalCommonPage;

    // TODO: consider adding case in reducer "ADD_PAGE" "REMOVE_PAGE" instead of just SET
    dispatch(setCommonPages(updated));

    // for each booking, add (or update?) the common pages
    const bookings = curBookingsBookingsSelector(getState());
    const updatedBookings = bookings.map((booking) => {
      let fileSelected = booking.fileSelected;
      const newFileSelectedD = new FileSelected(
        fileSelected,
      ).addCommonPagesToAllDestFilesWithSrcFile(
        srcFile,
        pageNum,
        fromGlobalCommonPage, // helps finding where to add global common page in the list
      );
      return {
        ...booking,
        fileSelected: newFileSelectedD,
      };
    });

    dispatch(curBookingsActions.setCurBookings(updatedBookings));
  };
};

/**
 * TODO: check if need page num or index
 * @param srcPartId
 * @param srcPageNum
 */
const addPage = (srcPartId: string, srcPageNum: number) => {
  return (dispatch, getState) => {
    const commonPages = commonPagesSelector(getState());
    const commonPagesM = new CommonPages(commonPages);
    const res = commonPagesM.addPage(srcPartId, srcPageNum);
    const updated = res.result as CommonPagesI;
    // TODO: consider adding case in reducer "ADD_PAGE" "REMOVE_PAGE" instead of just SET
    dispatch(setCommonPages(updated));
  };
};

const removePage = (pageIndex: number) => {
  return (dispatch, getState) => {
    const commonPages = commonPagesSelector(getState());
    const commonPagesM = new CommonPages(commonPages);
    const removedPageRes = commonPagesM.removePage(pageIndex);
    if (!removedPageRes) return;
    const { result: updated, fromGlobalPage } = removedPageRes;
    dispatch(setCommonPages(updated as EachPage[]));

    const bookings = curBookingsBookingsSelector(getState());
    const updatedBookings = bookings.map((booking) => {
      let fileSelected = booking.fileSelected;
      const newFileSelectedD = new FileSelected(
        fileSelected,
      ).removeCommonPage(fromGlobalPage);
      return {
        ...booking,
        fileSelected: newFileSelectedD,
      };
    });

    dispatch(curBookingsActions.setCurBookings(updatedBookings));
  };
};

const addPageAfterPageIndex = (
  srcPartId: string,
  srcPageNum: number,
  afterCommonPageIndex: number,
) => {
  return (dispatch, getState) => {
    const commonPages = commonPagesSelector(getState());
    const commonPagesM = new CommonPages(commonPages);
    const {
      result: updated,
      fromGlobalCommonPage,
    } = commonPagesM.addPageAfterPageIndex(
      srcPartId,
      srcPageNum,
      afterCommonPageIndex,
    );
    dispatch(setCommonPages(updated as CommonPagesI));

    const bookings = curBookingsBookingsSelector(getState());
    const updatedBookings = bookings.map((booking) => {
      let fileSelected = booking.fileSelected;
      const newFileSelectedD = new FileSelected(
        fileSelected,
      ).addCommonPageAfterFromGlobalCommonPageToAllDestFiles(
        srcPartId,
        srcPageNum,
        fromGlobalCommonPage,
      );
      return {
        ...booking,
        fileSelected: newFileSelectedD,
      };
    });

    dispatch(curBookingsActions.setCurBookings(updatedBookings));
  };
};

/**
 * can only move within the commonPages
 * @param oldPageIndex
 * @param insertAfterPageIndex
 */
const movePage = (
  oldPageIndex: number,
  insertAfterPageIndex: number,
) => {
  return (dispatch, getState) => {
    const commonPages = commonPagesSelector(getState());
    const commonPagesM = new CommonPages(commonPages);
    const {
      result,
      fromFromGlobalPage,
      toFromGlobalPage,
    } = commonPagesM.movePage(oldPageIndex, insertAfterPageIndex);
    const updated = result as CommonPagesI;
    // TODO: consider adding case in reducer "ADD_PAGE" "REMOVE_PAGE" instead of just SET
    dispatch(setCommonPages(updated));

    const bookings = curBookingsBookingsSelector(getState());
    const updatedBookings = bookings.map((booking) => {
      let fileSelected = booking.fileSelected;
      const newFileSelectedD = new FileSelected(
        fileSelected,
      ).moveCommonPage(fromFromGlobalPage, toFromGlobalPage);
      return {
        ...booking,
        fileSelected: newFileSelectedD,
      };
    });
    dispatch(curBookingsActions.setCurBookings(updatedBookings));
  };
};

const clear = () => {
  return (dispatch, getState) => {
    dispatch(setCommonPages([]));

    const bookings = curBookingsBookingsSelector(getState());
    const updatedBookings = bookings.map((booking) => {
      let fileSelected = booking.fileSelected;
      const newFileSelectedD = new FileSelected(
        fileSelected,
      ).clearCommonPages();
      return {
        ...booking,
        fileSelected: newFileSelectedD,
      };
    });

    dispatch(curBookingsActions.setCurBookings(updatedBookings));
  };
};

export const commonPagesActions = {
  setCommonPages,
  addPage,
  removePage,
  addPageAfterPageIndex,
  movePage,
  addFileOrPage,
  clear,
};
